import { createFileRoute, stripSearchParams } from "@tanstack/react-router"
import { z } from "zod"
import { ChatPage } from "@/pages/chat"

const searchDefaults = { room: "general", friendName: "" } as const

const searchSchema = z.object({
	room: z.string().default(searchDefaults.room).catch(searchDefaults.room),
	friendName: z
		.string()
		.default(searchDefaults.friendName)
		.catch(searchDefaults.friendName),
})

export const Route = createFileRoute("/_authenticated/chat/")({
	validateSearch: searchSchema,
	search: { middlewares: [stripSearchParams(searchDefaults)] },
	component: ChatRouteWrapper,
})

function ChatRouteWrapper() {
	const { room, friendName } = Route.useSearch()
	return <ChatPage room={room} friendName={friendName} />
}
